/* eslint-disable no-console */
import type { QueryKey } from '@tanstack/react-query';

import { epiPageQueryKeys } from '../../episerver/epiQueryKeys';
import { coopQueryClient } from './coopQueryClient';

const errorPrefix = 'Coop.se performance warning: Invalid initial query data found in DOM.';

export const getMicroAppInitialQueryData = () => {
    const initialQueryDataDom = document.querySelectorAll<HTMLElement>('.initial-query-data');
    return initialQueryDataDom?.length > 0
        ? Array.from(initialQueryDataDom).map(getInitialQueryDataFromDOM).filter(Boolean)
        : undefined;
};

export const setMicroAppInitialQueryData = (
    initialQueryData: ReturnType<typeof getMicroAppInitialQueryData>,
) => {
    if (initialQueryData?.length) {
        console.logDev('Initial query data found, setting in query client:', initialQueryData);
        initialQueryData.filter(Boolean).forEach((item) => {
            const { key, data } = item;
            coopQueryClient.setQueryData(key, data);
        });
    }
};

export const getInitialQueryDataFromDOM = (
    container: HTMLElement | null,
): { key: QueryKey; data: unknown } | undefined => {
    if (!container) {
        return;
    }

    const domModelString = container.innerText;
    const domDepth = container.dataset?.depth;
    const domType = container.dataset?.type;
    const domUrl = container.dataset?.url;
    const domContentReference = container.dataset?.contentReference;

    if (!domModelString) {
        console.warn(errorPrefix, 'No serialized model found.');
        return undefined;
    }

    let domModel;
    try {
        domModel = JSON.parse(domModelString);
    } catch (_error) {
        console.warn(errorPrefix, 'Model could not be parsed.');
        return undefined;
    }

    if (!domDepth) {
        console.warn(errorPrefix, 'No depth parameter found.');
        return undefined;
    }

    switch (domType?.toLowerCase()) {
        case 'ByUrl'.toLowerCase(): {
            if (domUrl) {
                return {
                    key: epiPageQueryKeys.getByUrl(domUrl, {
                        depth: parseInt(domDepth, 10),
                    }),
                    data: domModel,
                };
            }
            console.warn(errorPrefix, 'No url found.');
            return undefined;
        }
        case 'ByContentReference'.toLowerCase(): {
            if (domContentReference) {
                return {
                    key: epiPageQueryKeys.getByContentReference(domContentReference, {
                        depth: parseInt(domDepth, 10),
                    }),
                    data: domModel,
                };
            }
            console.warn(errorPrefix, 'No ContentReference found.');
            return undefined;
        }
        default: {
            console.warn(errorPrefix, `Unknown type found: ${domType}.`);
            return undefined;
        }
    }
};
